/** 驗證碼驗證請求參數。 */
export interface IReqCaptcha {
  captchaUuid: string;
  captcha?: string;
}

/** 電子證書驗證請求參數。 */
export interface IReqCertVerify {
  file: File;
  captchaUuid: string;
  captcha: string;
}

/** 電子證書驗證回傳值。 */
export interface IResCertVerify {
  /** 回復結果代碼。 */
  verifyResultCode: string;
  /** 回復結果內容。 */
  verifyResult: string;
}

/** 電子證書下載請求參數。 */
export interface IReqCertDownload {
  /** 申請案號。 */
  certNo: string;
  /** 下載碼。 */
  dwnCode: string;
  /** 案件種類。 */
  caseType: string;
  captchaUuid: string;
  captcha: string;
}

/** 電子證書下載回傳值。 */
export interface IResCertDownload {
  /** 回傳狀態代碼。 */
  status: string;
  /** 回傳狀態說明。 */
  msg: string;
  /** 專利電子證書PDF檔下載URL */
  pdfUrl: string;
}

/**
 * 案件種類。
 */
export enum CaseType {
  P = '專利',
  T = '商標',
}

/**
 * 電子證書驗證回傳代碼。
 */
export enum CertVerifyCode {
  /** 驗證成功 */
  V01 = 'v01',
  /** 僅限新版電子證書驗證 */
  V02 = 'v02',
  /** 證書非有效，已另換發或補發 */
  V03 = 'v03',
}
/**
 * 電子證書下載回傳代碼。
 */
export enum CertDownCode {
  /** 正常 */
  D00 = '0',
  /** 查無資料 */
  D01 = '1',
  /** 已超過可下載期限 */
  D02 = '2',
  /** 此證書非有效，已另換發或補發 */
  D03 = '3',
  /** 系統運作發生異常 */
  D04 = '-1',
  /** 缺少必要欄位或資料格式錯誤 */
  D05 = '-2',
}
